import { createApp } from "vue"
import FunTipsDialog from "./logInCn.vue"
import vue3GoogleLogin from "vue3-google-login"

let isLogInShow = false

export default function LogIn(options) {
  if (isLogInShow) return
  isLogInShow = true
  const mountNode = document.createElement("div")
  document.body.appendChild(mountNode)
  const app = createApp(FunTipsDialog, {
    ...options,
    visible: true,
    remove() {
      isLogInShow = false
      app.unmount()
      document.body.removeChild(mountNode)
    },
  })
  app.use(vue3GoogleLogin, {
    clientId: "1069642802272-0ktgtg6hn72ljht0bltd9h14qseflsvj.apps.googleusercontent.com",
    scope: "profile email",
  })
  const instance = app.mount(mountNode)
  // 给外部返回一个 close 方法
  instance.close = function () {
    if (typeof instance.remove === 'function') {
      instance.remove()
    }
  }
  return instance
}
